import {Conversation} from '@stripe-internal/conversations-client';
import {UniversalHelpConversationContext} from '../Providers/ClientProvider/UHLiveChannelsClient';
import {buildTranscript} from './buildTranscript';
import {RequestIssueContext} from '../../generated/types';

export type UHIssueContext = RequestIssueContext;

export const buildUHConversationIssueContext = (
  conversation: Conversation,
): UHIssueContext => {
  const uhContext = conversation.context.universalHelp as
    | UniversalHelpConversationContext
    | undefined;

  const issueContext: UHIssueContext = {
    articlesVisited: uhContext?.articlesVisited
      ? Object.keys(uhContext.articlesVisited)
      : [],
    icTagsEncountered: [],
    transcript: buildTranscript(conversation),
  };

  return issueContext;
};
